import React, { createContext, useContext, useState, useEffect } from "react";
import axiosInstance from "../api/Axios";
import { API_ENDPOINTS } from "../constants/api";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Функция для загрузки данных пользователя
  const fetchUser = async () => {
    try {
      const response = await axiosInstance.get(API_ENDPOINTS.ME);
      setUser(response.data.user);
      setIsAuthenticated(true);
    } catch (error) {
      console.log("fetchUser error:", error);
      console.log("fetchUser error response:", error.response?.data);
      setUser(null);
      setIsAuthenticated(false);
      // Удаляем недействительные токены
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      
      // Перенаправляем на страницу входа при ошибках авторизации
      if (error.response?.status === 401 || 
          error.response?.status === 403 ||
          error.response?.data?.message === "err_user_not_auth") {
        if (window.location.pathname !== '/login' && window.location.pathname !== '/register') {
          window.location.href = '/login';
        }
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    const refreshToken = localStorage.getItem("refresh_token");
    console.log("useAuth useEffect - token:", token ? "exists" : "not found");
    console.log("useAuth useEffect - refreshToken:", refreshToken ? "exists" : "not found");
    
    if (token && refreshToken) {
      // Если есть токен, пытаемся получить данные пользователя
      fetchUser();
    } else {
      // Если токенов нет, сразу устанавливаем состояние как неавторизованное
      setIsAuthenticated(false);
      setUser(null);
      setLoading(false);
      // Перенаправляем на страницу входа, если мы не на ней
      if (window.location.pathname !== '/login' && window.location.pathname !== '/register') {
        window.location.href = '/login';
      }
    }
  }, []);

  const login = async (username, password) => {
    try {
      console.log("useAuth login - starting login process");
      console.log("useAuth login - API URL:", axiosInstance.defaults.baseURL);
      const response = await axiosInstance.post(API_ENDPOINTS.LOGIN, {
        username,
        password,
      });
      
      if (response.status === 200) {
        const { access_token, refresh_token } = response.data;
        console.log("useAuth login - tokens received, saving to localStorage");
        localStorage.setItem("access_token", access_token);
        localStorage.setItem("refresh_token", refresh_token);
        console.log("useAuth login - setting isAuthenticated to true");
        setIsAuthenticated(true);
        await fetchUser();
        console.log("useAuth login - login successful");
        return response.data;
      }
    } catch (error) {
      console.error("useAuth login error:", error);
      console.error("useAuth login error response:", error.response);
      throw error;
    }
  };

  const logout = async () => {
    try {
      console.log("useAuth logout - starting logout process");
      const refreshToken = localStorage.getItem("refresh_token");
      
      if (refreshToken) {
        // Отправляем запрос на сервер для отзыва токена
        await axiosInstance.post(API_ENDPOINTS.LOGOUT, { refreshToken });
      }
    } catch (error) {
      console.error("useAuth logout error:", error);
    } finally {
      console.log("useAuth logout - clearing tokens and state");
    localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
    setIsAuthenticated(false);
    setUser(null);
    }
  };

  const updateUser = (updatedUserData) => {
    console.log("useAuth updateUser - updating user data:", updatedUserData);
    setUser(prevUser => ({ ...prevUser, ...updatedUserData }));
  };

  console.log("useAuth render - isAuthenticated:", isAuthenticated, "loading:", loading);

  return (
    <AuthContext.Provider value={{ isAuthenticated, user, loading, login, logout, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}; 